// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabGuardarCerrar extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.guardar_cerrar";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabGuardarCerrar {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "Desar i sortir",
                "cz": "Uložit a zavřít",
                "da": "Gem og luk",
                "de": "Speichern und schließen",
                "en": "Save and exit",
                "eu-ES": "Gorde eta itxi",
                "fi": "Tallenna ja poistu",
                "fr": "Enregistrer et quitter",
                "ga-ES": "Gardar e pechar",
                "hi": "सहेजें और बंद करें",
                "hu": "Mentés és bezárás",
                "it": "Salvare e chiudere",
                "no": "Lagre og lukk",
                "nl": "Bewaren en opslaan",
                "pl": "Zapisz i zamknij",
                "pt": "Guardar e fechar",
                "pt-BR": "Salvar e fechar",
                "ro": "Salvează și închide",
                "ru": "Сохранить и закрыть",
                "sv": "Spara och avsluta",
                "sk": "Uložiť a ukončiť"
            },
            "defecto": "Guardar y cerrar"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
